import Vue from 'vue'

const requireComponent = require.context(
  '@/components/base', true, /\.vue$/,
)

function toPascalCaseFromPath (filePath) {
  const name = filePath.replace(/^\.\//, '').replace(/\.\w+$/, '')
  // Only use the base filename (ignore nested directories)
  const base = name.split('/').pop() || ''
  if (!base) return ''
  // If already PascalCase (e.g., MaterialCard), preserve casing
  if (/^[A-Z][A-Za-z0-9]*$/.test(base)) return base
  // Otherwise, split on non-alphanumerics and capitalize
  const parts = base.split(/[^A-Za-z0-9]+/).filter(Boolean)
  return parts.map(p => p.charAt(0).toUpperCase() + p.slice(1)).join('')
}

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = toPascalCaseFromPath(fileName)
  Vue.component(`Base${componentName}`, componentConfig.default || componentConfig)
})
